import { render, staticRenderFns } from "./Gonggaodetails.vue?vue&type=template&id=317c1d6b&scoped=true"
import script from "./Gonggaodetails.vue?vue&type=script&lang=js"
export * from "./Gonggaodetails.vue?vue&type=script&lang=js"
import style0 from "./Gonggaodetails.vue?vue&type=style&index=0&id=317c1d6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317c1d6b",
  null
  
)

export default component.exports